let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("h17IG")).then(() => parcelRequire('6fBb8'));